import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';
import {  GroupService, PageService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';
import { ApiService } from 'src/app/_services/api.service';


@Component({
  selector: 'app-manutenzioni',
  templateUrl: './manutenzioni.component.html',
  styleUrls: ['./manutenzioni.component.css'],
  providers: [DetailRowService,SortService,ToolbarService,GroupService,PageService]
})
export class ManutenzioniComponent implements OnInit {
  @ViewChild('grid') public grid: any;
  pageTitle='';
  filter='';
  manutenzioni:any=[];
  totRecords:number=0;
  public toolbar: string[];
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.toolbar = ['Search'];

    this.filter=this.route.snapshot.paramMap.get('filter');
    if((!this.filter)||(this.filter=='arkimannonpresiincarico')){
      this.filter='arkimannonpresiincarico';
      this.pageTitle='Manutenzioni non prese in carico';
    }
    if(this.filter=='arkimanincaricogestionemanutenzioni'){
      this.pageTitle='Manutenzioni in carico gestione manutenzioni';
    }
    if(this.filter=='arkimanmanutentore'){
      this.pageTitle='Manutenzioni in carico manutentore';
    }
    if(this.filter=='arkimanincaricodirezionestruttura'){
      this.pageTitle='Manutenzioni in carico direzione struttura';
    }
   
    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('users/logininfokpi',params).subscribe(data => {
      let params=data.Result[0];
      this.apiService.get('todo/'+this.filter,params).subscribe(data => {
        this.manutenzioni=data.Result;
        this.totRecords=this.manutenzioni.length;
        this.grid.localeObj.currentLocale.EmptyRecord = 'Nessun dato da visualizzare ...'; 
      });
    });
    
  }
  
  onLoad() { 
    this.grid.localeObj.currentLocale.EmptyRecord = 'Caricamento in corso...'; 
  }

  goto(){
    this.router.navigateByUrl('/java/arkiman/login/LogonServletMAN?oper=1'.replace('?','QUESTION').replace('=','UGUAL'));    
  }

  apri(data){
   
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        oper:1,
        reind:'manutenzione',
        id_manutenzione:data.id,
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiman/login/LogonServletMAN','POST',params);
  
   
    
  }
}
